import { Component, OnInit, EventEmitter } from '@angular/core';
import { Router } from "@angular/router";
import { MaterializeAction } from "angular2-materialize";
import { ApiRequestService } from "../../../_services/api-request.service";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

declare var AOS:any;
declare var Materialize: any;
declare var $: any;

@Component({
  selector: 'app-driver',
  templateUrl: './driver.component.html',
  styleUrls: ['./driver.component.css']
})
export class DriverComponent implements OnInit {

  drivername = '';
  insuranceModal = new EventEmitter<string | MaterializeAction>();

  pdfview: SafeResourceUrl;
  FileDetail0: any;
  loader = false;
  pdfFiledata:any;
  page_content = 'upload_file';
  title = "Upload File";
  

  constructor(private router : Router,private apirequest: ApiRequestService, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    
  }


  workersComp(){
    window.open("https://otacon.us/workers-com","_blank")
  }

  driver(name:any) {
    this.drivername = name;
    this.init_animation();
  }

  pre_auth(){
    this.router.navigate(['/user/pre_auth/claim']);
  }

  claim(){
    this.router.navigate(['/user/claim']);
  }

  denied(){
    this.router.navigate(['/user/denied/claim']);
  }

  init_animation()
  {
    AOS.init();
  }

  msg_view(msg_data) {
    $(document).ready(function () {
      Materialize.toast(msg_data.toString(), 3000, "grey darken-4");
    });
  }

  insuranceModalOpen() {
    this.insuranceModal.emit({ action: "modal", params: ["open"] });
  }

  modal_close() {
    this.insuranceModal.emit({ action: "modal", params: ["close"] });
    this.page_content = 'upload_file';
    this.pdfFiledata = undefined;
    this.title = "Upload File";
  }

  onChange(file: any) {
      this.FileDetail0 = file;
      let ConsentFile = URL.createObjectURL(file);
      this.pdfview = this.sanitizer.bypassSecurityTrustResourceUrl(ConsentFile);
  }

  getResult() {
    this.loader = true;
    let input = new FormData();
    input.append("action", "upload_pdf");
    input.append("files", this.FileDetail0);
    input.append("run", "v1");
    this.apirequest.pdf_flow(input).subscribe((res) => {
      console.log(res);
      if (res.status == true) {
        this.loader = false;
        this.pdfFiledata = res.msg[0];
        console.log(this.pdfFiledata);
        this.title = "Result";
        this.page_content = 'result_section';        
      } else {
        this.msg_view(res.msg);
      }
    });
  }

  

}



// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/_components/components_user/driver/driver.component.ts